module.exports = __webpack_public_path__ + "img/arek.156ac9c4.jpg";